import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cspTransitionSkuPipe'
})

export class CspTransitionSkuPipe implements PipeTransform {
  // stock code = termId:ProduftId:skuId
  transform(toCatalogItemId: string, termId?: string): string {
    const array = toCatalogItemId.split(':');
    // array[0] = productId
    // array[1] = skuId

    return termId ? `${termId}:${array[0]}:${array[1]}` : `${array[0]}:${array[1]}`;
  }
}

